
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { COMPANY_LIST } from "@/constant";
import {
  createCustomerWhole,
  searchCustomer
} from "@/api/customer";
import {
  getPiCombinedUnit,
  getSupplierProduct,
  putPiCombinedUnit
} from "@/api/proforma";
import { deepClone } from "@/utils/deepClone";

@Component({
  name: "ModifyDiscounts"
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: "查看抵扣单据" }) private title: "";
  @Prop({ default: {} }) private selectedItem: {};

  @Watch("show", { immediate: true })
  private async watchData() {
    if ((this.selectedItem as any).id && this.show) {
      this.form = deepClone(this.selectedItem);
    }
  }

  private form = {} as any;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[]
  };
  public tableCol = [
    {
      label: "S/N",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false
    },
    {
      label: "单据号码",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false
    },
    {
      label: "单据类型",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false
    },
    {
      label: "抵扣类型",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false
    },
    {
      label: "抵扣额",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false
    }
  ];

  private close() {
    this.$emit("update:show", false);
  }

  private open() {
    this.$emit("update:show", true);
  }

  private async submitForm(): Promise<void> {
    this.putPiCombinedUnit();
  }

  private onSelectionChange(rows: any[]) {
    console.log(rows);
  }

  public async handleDelete(scope) {
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000
    });
  }


  // 更新组合单位
  private async putPiCombinedUnit() {
    const {
      hqProductName,
      supplier,
      shipmentQuantity,
      deliveryQuantity,
      deliveryChineseUnit,
      shipmentChineseUnit,
      deliveryEnglishUnit,
      shipmentEnglishUnit
    } = this.form;
    let params = {
      hqProductName,
      supplierAbbr: supplier,
      shipmentQuantity,
      deliveryQuantity,
      deliveryChineseUnit,
      shipmentChineseUnit,
      deliveryEnglishUnit,
      shipmentEnglishUnit
    };
    try {
      await putPiCombinedUnit(this.form.id, params);
      this.$notify({
        title: "成功",
        message: "创建成功",
        type: "success",
        duration: 2000
      });
      this.close();
      this.$emit("success", false);
    } catch {
    }
  }

  private async getPiCombinedUnit() {
    const res: any = await getPiCombinedUnit(this.form.id);
    this.getSupplierProduct(res.supplierId);
  }

  private async getSupplierProduct(supplierId) {
    const res: any = await getSupplierProduct(supplierId, {
      hqProductName: this.form.hqProductName
    });
    this.$set(this.form, "shipmentChineseUnit", res.chineseUnit || "");
    this.$set(this.form, "shipmentEnglishUnit", res.englishUnit || "");
    this.$set(this.form, "shipmentQuantity", 1);
    this.$set(this.form, "deliveryQuantity", 1);
  }
}
